import React, { useEffect, useState } from "react";
import Container from "../../common/Container";
import Action from "../../common/Actions"
import "../../index.css";
import SearchIcon from "@mui/icons-material/Search";
import InputWithIcon from "../../common/InputWithIcon";
import { TH, TD, TR, Thead, Tbody } from "../../styled/table";
import Add from "@mui/icons-material/Add";
import Button from "../../common/Button";
import PaginationDiv from "../../common/PaginationDiv";
import CustomAddPage from "../../components/custom-pages/CustomAddModal"
import { createDocument, deleteDocumentById, getAllData } from "../../apis/customApiHandler";
import { convertToIndianTimezoneAndGetDate, handleDownClick, handleUpClick } from "../../utils/helpers";
import { LinearProgress } from "@mui/material";
import checkPermission from "../../utils/checkPermission";

function VehicleMakes() {
  const [limit, setLimit] = useState(10);
  const [page, setPage] = React.useState(1);
  const [search, setSearch] = useState("")
  const [vehicleMakes, setVehicleMakes] = useState([])
  const [vehicleMake, setVehicleMake] = useState({})
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
    const [totalData, setTotalData] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [loading, setLoading] = useState(false)
  const currentUser = JSON.parse(localStorage.getItem("user"))
   const [productCategory, setProductCategory] = useState([])

  const getVehicleMake = async () => {
    setLoading(true)
    const data = await getAllData("/master/vehicle/getVehicleMake", {page, limit, search});
    setVehicleMakes(data?.data)
    setTotalData(data?.totalData)
    setTotalPage(data?.totalPage)
    setLoading(false)
  }
  useEffect(() => {
    getVehicleMake();
  }, [search, limit, page])

  const list = [
    {
      name: "Edit",
     condition: checkPermission([
    {
        permission: "masters",
        subPermission: ["UPDATE"]
    },
], currentUser),

      onClick: (make) => {
        setVehicleMake(make);
        setShowEditModal(true);
      },
      className: "text-grey",
    },
    {
      name: "Delete",
     condition: checkPermission([
    {
        permission: "masters",
        subPermission: ["DELETE"]
    },
], currentUser),onClick: async (make) => {
        setVehicleMake(make);
        await createDocument("/master/vehicle/updateVehicleMake?_id=" +  make?._id, {deleted: true});
        await getVehicleMake()
      },
      className: "text-error",
    },
  ];

  const getProductCategory = async () => {
    const data = await getAllData("/master/product/getProductCategory", {});
    console.log('product category',data?.data)
    setProductCategory(data?.data?.map(val=> {return {name: val.Ydesc, _id: val._id}}))
  }

  useEffect(()=>{
    getProductCategory();
  }, [])

  return (
    <Container>
      <div className="flex flex-col md:flex-row justify-between">
        <div className="grid grid-col-1 col-span-2 md:col-span-1 flex flex-col">
          <div className="font-semibold text-[24px]"> Vehicle Makes</div>
        </div>

        <div className="flex flex-row text-secondary h-12 gap-3 text-xl">
          <div className="">
            <Button
              text="Add New Vehicle Make"
              disabled = {!checkPermission([
                {
                    permission: "masters",
                    subPermission: ["CREATE"]
               ,},
            ], currentUser)}

              className="w-full flex flex-row border border-1 border-black items-center px-3 rounded-md h-12 text-[16px] font-medium text-white bg-dark-blue gap-3"
              Icon={<Add color="inherit" />}
              onClick={() => setShowAddModal(true)}
            />
          </div>
        </div>
      </div>
      <div className="mt-5">
        <InputWithIcon
          placeholder="Search for Vehicle Make..."
          variant="outlined"
          setData={setSearch}
          Icon={<SearchIcon className="text-dark-grey" />}
          className="w-80 border border-gray-300 items-center px-2 rounded-md h-12 text-[16px] shadow-sm"
          inputClass="text-[16px]"
        />
      </div>
      <table className="w-full table">
        <Thead className="flex flex-row justify-between w-full">
          <tr className=" flex flex-row justify-between w-full">
            {/* <TH className="" type="checkbox"> <input type="checkbox"></input></TH> */}
            <TH handleUpClick= {handleUpClick} handleDownClick={handleDownClick} setData={setVehicleMakes} field={"name"}>Make Name</TH>
            <TH handleUpClick= {handleUpClick} handleDownClick={handleDownClick} setData={setVehicleMakes} field={"description"}>Description</TH>
            <TH> Product Category </TH>
            <TH handleUpClick= {handleUpClick} handleDownClick={handleDownClick} setData={setVehicleMakes} field={"createdAt"}>Created On</TH>
            <TH>Actions</TH>
          </tr>
        </Thead>
        {loading ? <LinearProgress color="secondary" /> :
          <Tbody className="flex flex-col justify-between w-full">
            {vehicleMakes?.map((entry, index) => {
              console.log('entry1',entry);
              
              if (true)
                return (
                  <TR className="">
                    {/* <TD className="ml-2 text-center justify-center " type="checkbox"> <input type="checkbox"></input> </TD> */}
                    <TD> {entry.name} </TD>
                    <TD> {entry.description} </TD>
                    <TD> {entry.productCategory} </TD>
                    <TD> {convertToIndianTimezoneAndGetDate(entry.createdAt)} </TD>
                    <TD className="text-center"> <Action list={list} data={entry} /> </TD>
                  </TR>
                );
            })}
          </Tbody>
        }

      </table>
      <PaginationDiv
        page={page}
        setPage={setPage}
        length={totalData}
        limit={limit}
        setLimit={setLimit}
      />
      {showAddModal && <Create handleClick={async () => { setShowAddModal(false); await getVehicleMake() }} productCategory={productCategory} />}
      {showEditModal && <Create data={vehicleMake} handleClick={async () => { setShowEditModal(false); await getVehicleMake() }} productCategory={productCategory}/>}
    </Container>
  )
}
function Create({ data, handleClick,productCategory }) {
  const [initialValues, setInitialValues] = React.useState({
    name: data?.name || "",
    description: data?.description || "",
    productCategory: data?.productCategory || "",
  });

  const inputFields = [
    {
      name: "name",
      label: "Make Name",
      type: "text",
      required: true,
    },
    {
      name: "description",
      label: "Description",
      type: "text",
      required: true,
    },
     {
      name: "productCategory",
      label: "Product Category",
      type: "select",
      className: "w-full col-span-2",
      options: productCategory?.map(type=> {return {label: type.name, value: type.name}}),
      required: true,
    }
  ];
  return (
    <CustomAddPage
      pageTitle={data ? "Update Vehicle Make" : "Add Vehicle Make"}
      url={data ? "/master/vehicle/updateVehicleMake" : "/master/vehicle/addVehicleMake"}
      action={!data ? "create" : "post"}
      updateId={data?._id}
      queryKey="vehicleMake"
      inputFields={inputFields}
      data={initialValues}
      setData={setInitialValues}
      handleClick={handleClick}
    />
  );
}
export default VehicleMakes